<template>
  <div class="class-1">
    <!-- Header -->
    <AppHeader title="User Activity Logs" />

    <!-- Filters Section -->
    <div class="filters-container">
      <!-- Username Filter (changed from User ID) -->
      <div class="filter-group">
        <label for="usernameFilter">Filter by Username:</label>
        <input
          type="text"
          id="usernameFilter"
          v-model.trim="filters.username"
          placeholder="Enter username"
          @input="handleFilterChange"
        />
      </div>

      <!-- Date Range Filter -->
      <div class="filter-group">
        <label>Date Range:</label>
        <div class="date-range-inputs">
          <input
            type="date"
            v-model="filters.startDate"
            @change="handleFilterChange"
          />
          <span>to</span>
          <input
            type="date"
            v-model="filters.endDate"
            @change="handleFilterChange"
          />
        </div>
      </div>

      <!-- Clear Filters Button -->
      <button class="clear-filters-btn" @click="clearFilters">Clear Filters</button>
    </div>

    <!-- Logs Table -->
    <table id="logsTable">
      <thead>
        <tr>
          <th>ID</th>
          <th>Username</th>
          <th>Action (English)</th>
          <th>Action (Arabic)</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="log in logs.data" :key="log.id">
          <td>{{ log.id }}</td>
          <td>{{ log.user_name }}</td>
          <td>{{ log.en }}</td>
          <td>{{ log.ar }}</td>
          <td>{{ formatDisplayDate(log.created_at) }}</td>
        </tr>
      </tbody>
    </table>

    <!-- Pagination -->
    <div class="pagination" v-if="logs.total > logs.per_page">
      <button 
        @click="fetchLogs(logs.current_page - 1)" 
        :disabled="logs.current_page === 1"
      >
        Previous
      </button>
      <span>Page {{ logs.current_page }} </span>
      <button 
        @click="fetchLogs(logs.current_page + 1)" 
        :disabled="logs.current_page === logs.last_page"
      >
        Next
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    const today = new Date();
    const todayFormatted = today.toISOString().split('T')[0];
    return {
      logs: {
        data: [],
        current_page: 1,
        last_page: 1,
        per_page: 15,
        total: 0
      },
      filters: {
        username: '', // Changed from userId to username
        startDate: todayFormatted,
        endDate: todayFormatted
      },
      debounceTimer: null
    };
  },
  mounted() {
    this.fetchLogs();
  },
  methods: {
    formatDisplayDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },
    handleFilterChange() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.fetchLogs(1);
      }, 500);
    },
    clearFilters() {
      this.filters = {
        username: '', // Changed from userId to username
        startDate: null,
        endDate: null
      };
      this.fetchLogs(1);
    },
    async fetchLogs(page = 1) {
      try {
        this.$root.isLoading = true;
        const token = localStorage.getItem('authToken');
        
        // Build query parameters
        const params = new URLSearchParams();
        params.append('page', page);
        
        if (this.filters.username) {
          params.append('username', this.filters.username); // Changed from userId to username
        }
        
        if (this.filters.startDate) {
          params.append('startDate', this.filters.startDate);
        }
        
        if (this.filters.endDate) {
          params.append('endDate', this.filters.endDate);
        }

        const url = `${this.$BASE_API_URL}/api/logs/users?${params.toString()}`;
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (!response.ok) throw new Error('Failed to fetch logs');
        const data = await response.json();
        
        this.logs = data.data;

      } catch (error) {
        console.error('Error fetching logs:', error);
        this.$toast.error('Failed to fetch logs');
      } finally {
        this.$root.isLoading = false;
      }
    }
  },
};
</script>
<style scoped>
.filters-container {
  padding: 15px;
  border-radius: 5px;
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: flex-end;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.filter-group label {
  font-weight: bold;
  font-size: 0.9em;
}

.filter-group input {
  padding: 8px 12px;
  border: 1px solid;
  border-radius: 4px;
}

.date-range-inputs {
  display: flex;
  align-items: center;
  gap: 10px;
}

.date-range-inputs span {
  color: #666;
}

.clear-filters-btn {
  padding: 8px 16px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  height: fit-content;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  color: var(--font-color);
}

.pagination button {
  padding: 8px 16px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.pagination button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}
</style>